var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 8,
    fill: "#E7F0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 24C19 23.4477 18.5523 23 18 23H12C11.4477 23 11 23.4477 11 24V30C11 30.5523 11.4477 31 12 31H18C18.5523 31 19 30.5523 19 30V24Z",
    fill: "#E7F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24C31 23.4477 30.5523 23 30 23H24C23.4477 23 23 23.4477 23 24V30C23 30.5523 23.4477 31 24 31H30C30.5523 31 31 30.5523 31 30V24Z",
    fill: "#E7F0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 24C43 23.4477 42.5523 23 42 23H36C35.4477 23 35 23.4477 35 24V30C35 30.5523 35.4477 31 36 31H42C42.5523 31 43 30.5523 43 30V24Z",
    fill: "#E7F0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23.5C18.2761 23.5 18.5 23.7239 18.5 24V30C18.5 30.2761 18.2761 30.5 18 30.5H12C11.7239 30.5 11.5 30.2761 11.5 30V24C11.5 23.7239 11.7239 23.5 12 23.5H18ZM30 23.5C30.2761 23.5 30.5 23.7239 30.5 24V30C30.5 30.2761 30.2761 30.5 30 30.5H24C23.7239 30.5 23.5 30.2761 23.5 30V24C23.5 23.7239 23.7239 23.5 24 23.5H30ZM42 23.5C42.2761 23.5 42.5 23.7239 42.5 24V30C42.5 30.2761 42.2761 30.5 42 30.5H36C35.7239 30.5 35.5 30.2761 35.5 30V24C35.5 23.7239 35.7239 23.5 36 23.5H42Z",
    stroke: "#116DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderActive);
export default __webpack_public_path__ + "static/media/slider_active.eded110a786b4d2b9447eaa38b829e6f.svg";
export { ForwardRef as ReactComponent };